import React from "react";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { Avatar, Box, Chip, CircularProgress, Grid, Typography } from "@mui/material";
import TableComponent from "components/grid";
import TitleBar from "components/TitleBar";
import moment from "moment";

const rows = [
  {
    id: 1,
    title:
      "DG – External area (excluding Hotel, WH-1, ICD, BWH, IFT) – 500 KVA",
    poDate: "21 MAR, 2026",
    status: "Not Started",
    expectedDelivery: "N.A",
    deliveryDate: "N.A",
    avatar: "DG",
  },
  {
    id: 2,
    title: "Modular Tank - Fire Water & Domestic Water - SITC",
    poDate: "28 FEB, 2026",
    status: "Not Started",
    expectedDelivery: "N.A",
    deliveryDate: "N.A",
    avatar: "MD",
  },

];

const formatDate = (date) => {
  if (!date) return null;

  const m = moment(date);
  return m.isValid() ? m.format("DD MMM, YYYY").toUpperCase() : "N/A";
};

const LeadSummary = ({ data, isError, isLoading }) => {
  const rows = (data?.items || []).map((item) => ({
    title: item?.itemName || "N/A",
    poDate: formatDate(item?.poDate),
    status: item?.status || "N/A",
    actualDate: formatDate(item?.actualDate),
    plannedDate: formatDate(item?.plannedDate),
  }));

  const columns = [
    {
      name: "Items",
      field: "item",
      sticky: true,
      width: "40%",
      renderer: (row) => (
        <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
          {/* <Avatar
            sx={{
              width: 40,
              height: 40,
              bgcolor: "#F7C7C3",
              color: "#F15744",
              fontWeight: 500,
              fontSize: 18,
            }}
          >
            {row.avatar}
          </Avatar> */}

          <Box>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 500,
                fontFamily: "Outfit",
                color: "#101828",
                mb: 0.5,
                maxWidth: 520,
              }}
            >
              {row.title}
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: 14,
                  fontFamily: "Outfit",
                  color: "#475467",
                }}
              >
                PO Date
              </Typography>

              <Chip
                icon={<CalendarTodayIcon sx={{ width: 10, height: 10 }} />}
                label={row.poDate}
                sx={{
                  height: 26,
                  fontSize: 11,
                  fontFamily: "Outfit",
                  bgcolor: "#E7E7EB",
                  color: "#433F5E",
                }}
              />
            </Box>
          </Box>
        </Box>
      ),
    },

    {
      name: "Status",
      field: "status",
      width: "10%",
      renderer: (row) => (
        <Chip
          label={row.status}
          sx={{
            height: 30,
            px: 0.5,
            fontSize: 12,
            fontFamily: "Outfit",
            fontWeight: 600,
            bgcolor: "#F2F2F7",
            color: "#433F5E",
            borderRadius: "3px",
          }}
        />
      ),
    },

    {
      name: "Planned Date",
      field: "plannedDate",
      width: "25%",
      renderer: (row) => (
        <Chip
          icon={<CalendarTodayIcon sx={{ width: 10, height: 10 }} />}
          label={row.plannedDate ? moment(row.plannedDate).format("DD MMM YYYY") : "-"}
          sx={{
            height: 28,
            fontSize: 11,
            fontFamily: "Outfit",
            bgcolor: "#E7E7EB",
            color: "#433F5E",
          }}
        />
      ),
    },

    {
      name: "Actual Date",
      field: "actualDate",
      width: "25%",
      renderer: (row) => (
        <Chip
          icon={<CalendarTodayIcon sx={{ width: 10, height: 10 }} />}
          label={row.actualDate ? moment(row.actualDate).format("DD MMM YYYY") : "-"}
          sx={{
            height: 28,
            fontSize: 11,
            fontFamily: "Outfit",
            bgcolor: "#E7E7EB",
            color: "#433F5E",
          }}
        />
      ),
    },
  ];

  if (isLoading) {
    return (
      <Box
        sx={{
          minHeight: 200,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }


  if (isError) {
    return (
      <Box
        sx={{
          minHeight: 200,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography color="error">
          Failed to load long lead items.
        </Typography>
      </Box>
    );
  }


  return (
    <Grid container>
      <Grid size={12}>
        {/* <Box
          sx={{
            width: "100%",
            borderBottom: "1px solid #E4E4E4",
            p: 1.5,
            display: "flex",
            justifyContent: "space-between",
            boxSizing: "border-box",
          }}
        >
          <Box>
            <Typography
              variant="subtitle1"
              sx={{
                fontFamily: "Outfit, sans-serif",
                fontWeight: 600,
                fontSize: "20px",
                letterSpacing: "0px",
                mb: 0,
              }}
            >
              Long Lead items Summary
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontFamily: "Outfit, sans-serif",
                fontWeight: 300,
                fontSize: "16px",
                letterSpacing: "0px",
                color: "#7D7F81",
              }}
            >
              Highlights status and schedule of critical long-lead items that
              can impact overall project timelines.
            </Typography>
          </Box>
        </Box> */}
        <TitleBar title={"Long Lead items Summary"} description={"Highlights status and schedule of critical long-lead items that can impact overall project timelines."} />
        {rows?.length > 0 ? <Box>
          <TableComponent
            columns={columns}
            data={rows}
            isLoading={isLoading}
            createSortHandler={() => { }}
          />
        </Box> : <Box
          sx={{
            minHeight: 200,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: 14,
              fontFamily: "Outfit",
              color: "#98A2B3",
            }}
          >
            No long lead items available.
          </Typography>
        </Box>}
      </Grid>
    </Grid>
  );
};

export default LeadSummary;
